/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
import { isPlatformBrowser } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { StorageEnum } from '../../shared/enums/storage.enum';
import { type AccountDetail } from '../../shared/models/account-detail';
import { map } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, Validators } from '@angular/forms';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// import { MailingAddress } from '../../shared/models/mailing-address';
import { MailingAddressComponent } from '../../shared/components/mailing-address/mailing-address.component';
import { MatSelectModule } from '@angular/material/select';
import { States } from '../../shared/enums/states.enum';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { type UserProfile } from '../../shared/models/user-profile';
import { postalCodeValidator } from '../../shared/validators/postalCode.validator';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Address } from '../../shared/models/address';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { MailingAddressService } from '../../shared/services/mailing-address.service';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
import { NotificationType } from '../../shared/enums/notificationtype.enum';

@Component({
  selector: 'app-change-address',
  imports: [
    MatDividerModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MailingAddressComponent,
    MatSelectModule,
    MatCheckboxModule,
    PageHeaderComponent,
    RouterModule,
    NotificationComponent,
  ],
  templateUrl: './change-address.component.html',
  styleUrl: './change-address.component.scss',
})
export class ChangeAddressComponent {
  pageLabels: any = {};
  pageReady = false;
  formErrorMessage?: string = '';
  mailingAddressFormData: any = {};
  accountDetail: AccountDetail;
  loginRes: UserProfile;
  hasEmail: boolean = false;
  isBrowser = false;
  isMultiAccount: boolean = false;
  addressList: Address[] = [];
  userVerifiedAddress: boolean = false;
  unverifiedAddress: boolean = false;
  unverifiedAddressChanged: boolean = false;
  headerData = new PageHeader();
  pageName = 'Change Address';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly utils: UtilService,
    private readonly storage: StorageService,
    private readonly formBuilder: FormBuilder,
    private readonly mailingAddressService: MailingAddressService,
    private readonly router: Router,
    private readonly error: ErrorService,
    private readonly seoS: SeoService,
    private readonly notifi: NotificationsService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    this.loginRes = this.storage.getSession(StorageEnum.LoginResponse);
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-change-mailing-address', 'OAS Change Mailing Address')
      .pipe(
        map((data) => {
          this.pageLabels = data;
          this.headerData.Message = this.pageLabels.changeAddressHeader;
          this.seoS.setSeoTags(data.seo);
        }),
      )
      .subscribe((data) => {
        if (this.isBrowser) {
          this.setupMailingAddressData();
          this.pageReady = true;
          this.utils.hideSpinner();
        }
      });
  }

  setupMailingAddressData(): void {
    if (this.loginRes.TotalNumAccounts && this.loginRes.TotalNumAccounts > 1) {
      this.isMultiAccount = true;
    }
    this.mailingAddressFormData.isMultiAccount = this.isMultiAccount;
    this.mailingAddressFormData.formGroup = this.formBuilder.group({
      address1: ['', [Validators.required]],
      address2: [''],
      city: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalCodeValidator()]],
      state: [States.GA],
      setDefault: [false],
      addressRadioGroup: [''],
    });

    this.mailingAddressFormData.addressList = this.addressList;
  }

  updateMailingAddress(): void {
    this.formErrorMessage = '';
    if (this.mailingAddressFormData.formGroup.valid) {
      this.utils.showSpinner();
      if (
        (!this.mailingAddressFormData.formGroup.get('addressRadioGroup').value && !this.unverifiedAddress) ||
        this.unverifiedAddressChanged
      ) {
        this.verifyMailingAddress();
      } else {
        this.mailingAddressService
          .updateMailingAddress(this.mailingAddressFormData.formGroup, this.accountDetail, this.isMultiAccount)
          .subscribe({
            error: (e) => {
              void this.router.navigateByUrl(Nav.ManageAccount + '?errorMessage=changeMailingAddressErrorText');
            },
            next: (data: any) => {
              if (data === 'Success') {
                void this.router.navigateByUrl(Nav.ManageAccount + '?successMessage=changeMailingAddressSuccessText');
              }
            },
          });
      }
    } else {
      // Mark all controls as touched to trigger validation messages
      this.mailingAddressFormData.formGroup.markAllAsTouched();
      this.showFormErrorLabel();
    }
  }

  verifyMailingAddress(): void {
    this.unverifiedAddressChanged = false;
    this.mailingAddressService.mailingAddressVerification(this.mailingAddressFormData.formGroup).subscribe({
      error: (e) => {
        this.addressList.length = 0;
        this.unverifiedAddress = true;
        this.utils.hideSpinner();
      },
      next: (data: any) => {
        if (data) {
          this.addressList.pop();
          this.addressList.pop();
          this.addressList.push(data[0]);
          this.addressList.push(data[1]);
          this.mailingAddressFormData.addressList = this.addressList;
          this.mailingAddressFormData.formGroup.get('addressRadioGroup').setValue(this.addressList[0]);
          this.mailingAddressFormData.formGroup.get('address1')?.setValue(data[0].Address1);
          this.mailingAddressFormData.formGroup.get('address2')?.setValue(data[0].Address2);
          this.mailingAddressFormData.formGroup.get('city')?.setValue(data[0].City);
          this.mailingAddressFormData.formGroup.get('postalCode')?.setValue(data[0].PostalCode);
          this.mailingAddressFormData.formGroup.get('state')?.setValue(data[0].State);
          this.utils.hideSpinner();
        }
      },
    });
  }

  showFormErrorLabel(): void {
    this.formErrorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
    if (this.formErrorMessage !== '' && this.formErrorMessage) {
      this.notifi.clearAllNotifications(this.pageName);
      this.notifi.addNotification(this.formErrorMessage, NotificationType.Error, this.pageName);
    }
  }

  unverifiedAddressData(data: boolean): void {
    this.unverifiedAddressChanged = data;
  }
}
